import { ActiveParticipantService } from '../../../services/participants/active-participant.service';
import {Component, OnDestroy, OnInit } from '@angular/core';
import {
	IParticipant,
	IQuestionnaireWorkflowItem,
	IWorkflow,
	IWorkflowItem
} from '@interfaces/interfaces';
import { Observable, Subscription } from 'rxjs';
import { ProjectDto } from '@api/projects/interfaces';
import { ProjectRestService } from 'src/app/services/rest/project-rest.service';
import { UserDto } from '@api/users/interfaces';
import { UserRestService } from 'src/app/services/rest/user-rest.service';
import { WorkflowCategory, WorkflowService } from 'src/app/workflow/services/workflow.service';
import { MessplatzService } from '../../../services/messplatz/messplatz.service';

@Component({
	selector: 'app-projektflowchart',
	templateUrl: './projektflowchart.component.html',
	styleUrls: ['./projektflowchart.component.scss']
})
export class ProjektFlowchartComponent implements OnInit, OnDestroy {

	users$: Observable<UserDto[]>;
	projects$: Observable<ProjectDto[]>;
	participant: IParticipant;
	workflow: IWorkflow;
	categories: WorkflowCategory[];
	private subscription = new Subscription();

	constructor(
		private activeParticipant: ActiveParticipantService,
		private projectRestService: ProjectRestService,
		private userRestService: UserRestService,
		private workflowService: WorkflowService,
		private messplatzService: MessplatzService,
	) {
	}

	ngOnInit(): void {
		this.users$ = this.userRestService.listUsers$();
		this.projects$ = this.projectRestService.listProjects$();
		
		this.subscription.add(
			this.activeParticipant.participant$.subscribe(participant => {
				this.participant = participant;
			})
		);
		this.subscription.add(
			this.workflowService.workflow$.subscribe(workflow => this.workflow = workflow)
		);
		this.subscription.add(
			this.workflowService.workflowCategories$.subscribe(categories => this.categories = categories)
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	getWorkflowItemAsQuestionnaire(questionnaire: IWorkflowItem): IQuestionnaireWorkflowItem {
		return questionnaire as IQuestionnaireWorkflowItem;
	}

	getRecommendedLink(workflowItem: IWorkflowItem, pageNumber: number): string {
		const question = workflowItem as IQuestionnaireWorkflowItem;
		const group = question.groups[pageNumber];
		return this.workflowService.hasAllDevicesByPage(group) ?
			`wizard/${workflowItem.id}/${pageNumber}` : `compact/${workflowItem.id}`;
	}

	hasAllDevices(workflowItem: IWorkflowItem): boolean {
		return this.workflowService.hasAllDevicesbyQuestionnaire(workflowItem as IQuestionnaireWorkflowItem);
	}
}
